import { Link } from "react-router-dom";
import { WHAT_I_DO_ITEMS } from "../../content/contentBlocks";
import { toCardImage } from "../../lib/cardImage";
import { wizardProductHref } from "../../lib/wizardEntry";

export function WhatIDoBlock(): JSX.Element {
  return (
    <section className="w-full bg-white dark:bg-gray-950 border-y border-gray-100 dark:border-gray-800">
      <div className="w-full max-w-[1200px] mx-auto px-4 sm:px-6 md:px-8 py-10 md:py-12">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
          <h2 className="font-playfair text-2xl md:text-3xl text-gray-900 dark:text-gray-100">What I do</h2>
          <Link
            to="/services"
            className="text-sm font-semibold text-wwwuxmichalcomdodger-blue hover:underline shrink-0"
          >
            Products &amp; services →
          </Link>
        </div>

        <ul
          className="flex gap-3 md:gap-4 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 snap-x snap-mandatory [scrollbar-width:none] [&::-webkit-scrollbar]:hidden list-none m-0 p-0"
          aria-label="What I do"
        >
          {WHAT_I_DO_ITEMS.map((item) => (
            <li key={item.number} className="snap-start shrink-0 w-[140px] sm:w-[160px] md:w-[172px]">
              <Link
                to={wizardProductHref(item.productId)}
                className="group flex flex-col h-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 overflow-hidden hover:border-wwwuxmichalcomdodger-blue/40 hover:shadow-md transition-all"
              >
                <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                  <img
                    src={toCardImage(item.image)}
                    alt=""
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                    decoding="async"
                    width={400}
                    height={300}
                  />
                </div>
                <div className="p-3 flex flex-col flex-1 min-h-0">
                  <span className="text-[10px] font-medium text-gray-600 dark:text-gray-400 mb-0.5">{item.number}</span>
                  <span className="font-playfair text-base leading-tight text-gray-900 dark:text-gray-100 group-hover:text-wwwuxmichalcomdodger-blue transition-colors">
                    {item.title}
                  </span>
                  <span className="mt-1 text-xs text-gray-500 font-['Open_Sans',Helvetica] line-clamp-2 leading-snug">
                    {item.description}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
